// import React from "react";
import {
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useTheme
} from "@mui/material";
export const DetailCardLoader = () => (
  <div className="bg-gray-100 drop-shadow p-2 grid grid-cols-6">
    <div className="col-span-4 flex flex-col gap-3">
      <Skeleton width={"60%"} variant="text" />
      <Skeleton width={"30%"} variant="text" />
      <Skeleton width={"70%"} variant="text" />
      <Skeleton width={"20%"} variant="text" />
    </div>
    <div className="col-span-2 flex justify-end">
      <Skeleton height={70} width={70} variant="circular" />
    </div>
  </div>
);

export const SearchAreaLoader = () => (
  <div className="drop-shadow p-1 grid grid-cols-4 gap-2">
    {Array(8)
      .fill(null)
      .map((_, index) => (
        <Skeleton key={`inputfield${index}`} height={50} variant="text" />
      ))}
    <div className="col-span-full flex justify-end gap-2">
    <Skeleton height={50} width={"8%"} variant="text" />
    <Skeleton height={50} width={"8%"} variant="text" />
    </div>
  </div>
);

export const TableLoader = () => {
  const theme = useTheme()
  return (
  <div className="grid grid-cols-4 gap-1">
    <div className="col-span-full grid grid-cols-4 gap-1">
      {Array(4)
        .fill(null)
        .map((_, key) => (
          <div key={key} style={{backgroundColor:theme.palette.grey[50]}} className="flex justify-center p-3">
            <Skeleton width={120} />
          </div>
        ))}
    </div>
    {Array(4)
      .fill(null)
      .map((_, key) => (
        <div
          key={key + 1}
          style={{backgroundColor:theme.palette.grey[100]}} 
          className="flex flex-col gap-1 p-3 justify-center items-center"
        >
          <Skeleton width={120} />
          <Skeleton width={120} />
          <Skeleton width={120} />
          <Skeleton width={120} />
          <Skeleton width={120} />
        </div>
      ))}
  </div>
)};

export const TableDataLoading = ({
  rows,
  cols,
}: {
  rows: number;
  cols: number;
}) => {
  return (
    <TableContainer className="border-2">
      <Table sx={{width:"100%"}} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow sx={{}}>
            {Array(cols)
              .fill(null)
              .map((_, index) => (
                <TableCell key={`tablecolid${index}`}>
                  <Skeleton height={28} />
                </TableCell>
              ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {Array(rows)
            .fill(null)
            .map((_, index) => (
              <TableRow
                key={`tablerow${index}`}
                // sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                {Array(cols)
                  .fill(null)
                  .map((_, index) => (
                    <TableCell sx={{border:0}} key={`tablecolid${index}`}>
                      <Skeleton height={18} />
                    </TableCell>
                  ))}
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const GraphLoader = () => (
  <div className="flex flex-col h-[100%] gap-11 align-bottom">
    <div className="col-span-full ps-5">
      <Skeleton width={"25%"} variant="text" />
    </div>
    <div className="grid grid-cols-12 h-[80%] gap-9 w-full">
      <div className="col-span-2 flex flex-col gap-2 h-[100%] justify-end items-end">
        <Skeleton variant="rectangular" width={80} height={"70%"} />
        <Skeleton variant="text" width={80} />
      </div>
      <div className="col-span-2 flex flex-col gap-2 h-[100%] justify-end items-end">
        <Skeleton variant="rectangular" width={80} height={"50%"} />
        <Skeleton variant="text" width={80} />
      </div>
      <div className="col-span-2 flex flex-col gap-2 h-[100%] justify-end items-end">
        <Skeleton variant="rectangular" width={80} height={"60%"} />
        <Skeleton variant="text" width={80} />
      </div>
      <div className="col-span-2 flex flex-col gap-2 h-[100%] justify-end items-end">
        <Skeleton variant="rectangular" width={80} height={"80%"} />
        <Skeleton variant="text" width={80} />
      </div>
    </div>
  </div>
);

export const ProfileCardLoader = () => (
  <div className="flex flex-col gap-4 p-3">
    <Skeleton width={"100%"} height={30} variant="rounded" />
    <Skeleton width={120} height={120} variant="circular" />
    <Skeleton width={"70%"} variant="text" />
    <Skeleton width={"40%"} variant="text" />
    <Skeleton width={"80%"} variant="text" />
    <Skeleton width={"30%"} variant="text" />
  </div>
);

function PageLoadSkeleton({
  variant = "form",
}: {
  variant?: "form" | "dashboard" | "search-with-table";
}) {
  if (variant == "dashboard") {
    return (
      <div className="flex flex-col gap-6 h-[91dvh] w-[100%] p-3">
        <div className="grid grid-cols-4 gap-3 h-[25%]">
          {Array(4)
            .fill(null)
            .map((_, key) => (
              <DetailCardLoader key={key + 4} />
            ))}
        </div>
        <div className="grid grid-cols-12 gap-3">
          <div className="col-span-8 ">
            <GraphLoader />
          </div>
          <div className="col-span-4">
            <ProfileCardLoader />
          </div>
        </div>
        <div className="grid grid-cols-4 gap-4">
          {Array(4)
            .fill(null)
            .map((_, key) => (
              <div key={key + 3} className="flex flex-col gap-2">
                <Skeleton variant="text" width={"70%"} />
                <Skeleton variant="text" width={"40%"} />
                <Skeleton variant="text" width={"90%"} />
              </div>
            ))}
        </div>
      </div>
    );
  }
  if (variant == "form") {
    return (
      <div className="h-[91dvh] w-[100%] p-3 flex flex-col gap-10">
        <div className="flex flex-col">
          <div className="grid grid-cols-12 gap-5">
            <Skeleton width={90} height={100} variant="rectangular" />
            <div className="col-span-2">
              <Skeleton variant="text" />
              <Skeleton width={"80%"} variant="text" />
            </div>
            <div className="col-span-2">
              <Skeleton variant="text" />
              <Skeleton width={"80%"} variant="text" />
            </div>
            <div className="col-span-2">
              <Skeleton variant="text" />
              <Skeleton width={"80%"} variant="text" />
            </div>
            <div className="col-span-3">
              <Skeleton variant="text" />
            </div>
            <div className="col-span-full flex flex-row gap-4">
              <Skeleton width={150} variant="text" />
              <Skeleton width={150} variant="text" />
              <Skeleton width={150} variant="text" />
            </div>
            <div className="col-span-6">
              <Skeleton height={40} width={"80%"} />
              <Skeleton height={40} width={"70%"} />
              <Skeleton height={40} width={"20%"} />
              <Skeleton height={40} width={"50%"} />
            </div>
            <div className="col-span-6">
              <Skeleton height={40} width={"80%"} />
              <Skeleton height={40} width={"70%"} />
              <Skeleton height={40} width={"20%"} />
              <Skeleton height={40} width={"50%"} />
            </div>
          </div>
        </div>

        <TableLoader />
      </div>
    );
  }
  if (variant == "search-with-table") {
    return (
      <div className="flex flex-col h-full w-full p-5 gap-8">
        <SearchAreaLoader />
        <TableDataLoading cols={5} rows={10} />
      </div>
    );
  }
}

export default PageLoadSkeleton;
